import {
    LIVE_BID_ACCEPTED,
    LIVE_BID_RETRACTED,
    LIVE_LOT_REOPENED,
    LIVE_MISSIVE,
    LIVE_NEXT_LOT_LOADED,
} from './actions';
import cloneDeep from 'lodash/cloneDeep';
import { createSelector } from 'reselect';
import { GlobalState } from '../rootReducer';

export type State = {
    byId: { [itemId: number]: number };
};

export const DEFAULT_STATE: State = {
    byId: {},
};

export default function reducer(state: State = DEFAULT_STATE, action: any = {}): State {
    switch (action.type) {
        case LIVE_BID_ACCEPTED:
        case LIVE_BID_RETRACTED:
        case LIVE_LOT_REOPENED:
        case LIVE_NEXT_LOT_LOADED:
            const existing = cloneDeep(state.byId);
            existing[action.payload.itemId] = Date.now();
            return {
                ...state,
                byId: existing,
            };
        case LIVE_MISSIVE:
            if (action.payload.isTimed && action.payload.missiveText === 'Fair Warning... This lot is about to close') {
                const existing = cloneDeep(state.byId);
                existing[action.payload.itemId] = -Date.now();
                return {
                    ...state,
                    byId: existing,
                };
            }

            return state;
        default:
            return state;
    }
}

/* SELECTORS */
const stateSelector = (state: GlobalState) => state.bidCountDown;
const idSelector = (state: GlobalState, itemId: number) => itemId;

const byIdSelector = createSelector(stateSelector, (state) => state.byId);

export const getCountDown: (state: any, selector: any) => number = createSelector(
    [byIdSelector, idSelector],
    (byId, id) => {
        return byId[id] || 0;
    }
);
